import { LineTab, LineTabs, LineTabsList } from 'components/LineTabs';
import { useIsNewDesign } from 'components/tables/list-table/filter-bar/useIsNewDesign';
import TimecardListWithFilters from 'pages/timecards/TimecardListWithFilters.tsx';
import { useTimecardViews } from 'pages/timecards/useTimecardViews';
import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
    matterId?: string;
    isInternalClient?: boolean;
}

const TimecardView: FC<Props> = ({ matterId, isInternalClient }) => {
    const [tabType, setTabType] = useState<'main' | 'draft'>('main');
    const isNew = useIsNewDesign();
    const views = useTimecardViews();

    if (!matterId) {
        return null;
    }

    return (
        <div className="flex h-full flex-col gap-4">
            {/* In the new design the list renders the views row, MAIN and DRAFT included. */}
            {isNew ? null : (
                <LineTabs value={tabType} onValueChange={(value) => setTabType(value === 'draft' ? 'draft' : 'main')}>
                    <LineTabsList>
                        {views.map(({ id, labelId }) => (
                            <LineTab key={id} value={id}>
                                <FormattedMessage id={labelId} />
                            </LineTab>
                        ))}
                    </LineTabsList>
                </LineTabs>
            )}
            <TimecardListWithFilters
                surface="matter"
                tabType={tabType}
                passiveFilters={`matter.id==(${matterId})`}
                disabledGroups={['timecards.group.client', 'timecards.group.case']}
                matterId={matterId}
                showTotalsByDefault={!isInternalClient}
            />
        </div>
    );
};

export default TimecardView;
